// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"284":"413b83843c409412b45a0c2692fc674f","398":"10cd5a97b8ad45737d3b55c92e529bfc"}[chunkId] + ".js";
};